<template>
    <div :ref="rootElement" class="analysis-bi-chart">
        <div class="srp-bi-chart" flex="o">
            <span v-if="props.isLoading" class="th-loading th-loading-spinner th-loading-lg mx-auto mt-[90px] block bg-grey-200"></span>
            <div flex="o" :class="`${containerClass} w-full h-full`" v-show="!props.isLoading">
            </div>
        </div>
        <div class="chart-no-data h-full w-full flex-col items-center justify-center gap-1" style="display: none">
            <CatHole2/>
            <div>{{ $t('noData') }}</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { withDefaults } from 'vue';
import { useBIChart } from '@/composables/use-bi-chart';
import { CatHole2 } from '@eureka/cat'

const props = withDefaults(defineProps<{
    configTaskFunc:() => Promise<any>,
    dataTaskFunc: () => Promise<any>,
    getChartStr: (data: { img: string, data: unknown[][] }) => void,
    colorFunc?: (data: any[]) => any[],
    chartKey: string,
    isLoading: boolean,
}>(), {
    isLoading: true,
});

const { rootElement, containerClass } = useBIChart(props);

</script>

<style lang="scss">
.srp-bi-chart {
    width: 100%;
    height: 100%;
    .world-cloud-wrapper {
        overflow: visible;
        .chart-tooltips-wrapper {
            font-size: 12px;
            line-height: 18px;
        }
    }
    &__container {
        width: 100%;
        height: 100%;
        .no-data {
            line-height: unset;
        }
    }
    svg[icon="SolidLoadingBars"] {
        font-size: 64px;
    }
    svg.world-cloud {
        width: 100%;
    }
    .loading-bar-for-ie {
        width: 64px;
        height: 64px;
    }
}
</style>
